import { BasePresenter } from "@presenters/base/base.presenter";
import { IAEAColumnDefinition, IBudgetFormBasicDataMasters } from "@models/*";
import { Base } from "@interfaces/base/base.interface";
import { useSelector } from "react-redux";
import { Dictionary, Utilities, Enums, String, Constants } from "@utils";
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";
import { store } from "@/store";
import dxDataGrid from "devextreme/ui/data_grid";
import DataGrid from "devextreme/ui/data_grid";

export interface ITableByProjectState {
    columns: BatchGridColumnProps[];
    dataSource: any[];
    readOnly: boolean;
    modalExcel?: boolean;
    setColumns(columns: BatchGridColumnProps[]): void;
    setDataSource(data: any): void;
    setReadOnly(readOnly: boolean): void;
    setModalExcel?(Modal: boolean): void;
}

export interface ITableByProject extends Base<ITableByProjectState> { }

export class TableByProjectPresenter extends BasePresenter<ITableByProject> {
    public basicFields: Dictionary<string, IAEAColumnDefinition>;
    public currentLabels: Dictionary<string, string>;
    public formMasters: IBudgetFormBasicDataMasters;
    public currentTableData: any;
    public summaryConfig: any;
    public currentBudget: any;

    private monthsToSum: string[];
    private _tableId: string = 'table-by-project';

    constructor(view: ITableByProject) {
        super(view);
        this.initializePresenter();
        this.initializeVariables();
        this.onChangeCellValue = this.onChangeCellValue.bind(this);
        this.onCellPreRender = this.onCellPreRender.bind(this);
        this.openCloseModalExcel = this.openCloseModalExcel.bind(this);
        this.onAddNewRow = this.onAddNewRow.bind(this);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    }

    //#region Public methods
    public get getCurrentData() {
        return this.currentTableData;
    }
    public getAllColumnsDefinitions() {
        this.dispatcher(this.context.budgetStore.getFormBudgetByProjectTablesColumnDefinition())
    }
    public initializeColumns() {
        this.initializeColumnsByColumnsDefinition();
    }
    public onAddNewRow(e: any) {
        //e.data = { ...this.initializeColumnsValueDefinition(true) };
    }
    public renderTableWithData(columns:any) {
        if (!Utilities.isNullEmptyObject(this.currentTableData) && !Utilities.isNullObject(this.formMasters)) {
            let currentData = this.currentTableData.map((row: any) => {
                return {
                    Id: row.Id,
                    FinanciadorSap: row.OCTAVIAFinanciadorSap ? [row.OCTAVIAFinanciadorSap.id] || [0] : [0],
                    CodigoSubvencion: row.PPresCodSubvencion ? [row.PPresCodSubvencion.id] || [0] : [0],
                    NaturalezaGastos: row.PPresNatuGasto ? [row.PPresNatuGasto.id] || [0] : [0],
                    RecuperacionCostes: row.ProaRecupCostes ? [row.ProaRecupCostes.id] || [0] : [0],
                    Pep: row.PPresCodPep,
                    PepManual: row.EdicionPepLibre ? row.PPresCodPep : null,
                    PepCalculado: row.PPresCodPep,
                    TotalAnio: row.PPresTotalAnio,
                    Enero: row.PPresEnero,
                    Febrero: row.PPresFebrero,
                    Marzo: row.PPresMarzo,
                    Abril: row.PPresAbril,
                    Mayo: row.PPresMayo,
                    Junio: row.PPresJunio,
                    Julio: row.PPresJulio,
                    Agosto: row.PPresAgosto,
                    Septiembre: row.PPresSeptiembre,
                    Octubre: row.PPresOctubre,
                    Noviembre: row.PPresNoviembre,
                    Diciembre: row.PPresDiciembre,
                    Pais: row.OCTAVIAPaisId ? [row.OCTAVIAPaisId] || [0] : [0],
                    EdicionPepLibre: row.EdicionPepLibre
                };
            });
            this.view.state.setDataSource(currentData);
        }

    }
    public onCellPreRender(e: any, column: BatchGridColumnProps): BatchGridColumnProps {
        const newColumn: BatchGridColumnProps = { ...column };
        if (column.dataField === Enums.ListTypes.Country && !Utilities.isNullEmptyObject(this.currentBudget.RegionCountry)) {
            const region = this.formMasters.regions.find((x: any) => x.OCTAVIACodigo === this.currentBudget.RegionCountry[0].code);
            if (!Utilities.isNullObject(region)) {
                newColumn.items = this.formMasters.countries.filter((x: any) => x.OCTAVIAActivo === true).map((value: any) => {
                    return {
                        id: value.ID,
                        label: value.Title,
                        code: value.OCTAVIACodigo
                    }
                });
            }
            else {
                newColumn.items = [];
            }
        }
        if(column.dataField === "CodigoSubvencion" ){
            if(e.data.FinanciadorSap && e.data.FinanciadorSap[0]){
                let Financer = this.formMasters.sapFinancingEntities.filter((sapFinancer:any)=>e.data.FinanciadorSap[0] == sapFinancer.Id)
                let isAeA = Financer[0] ? Financer[0].PPresTipoFondoId === 1 : false;
                newColumn.items = isAeA ? this.formMasters.grantCodes.filter((_codeAeA:any)=> (_codeAeA.Title && _codeAeA.Title[0] == "A" && _codeAeA.OCTAVIAActivo) )      
                    :   this.formMasters.grantCodes.filter((_code:any)=> (_code.OCTAVIAActivo && _code.OCTAVIAFinanciadorSapId == e.data.FinanciadorSap[0]) )
                newColumn.items = Utilities.processDropDownData(newColumn.items, Enums.ListTypes.GrantCode);
            }else newColumn.items = [];
        }
        return newColumn
    }
    public switchView() {
        const readOnly = window.location.hash.indexOf("view?Id") > -1;
        if (readOnly) { this.view.state.setReadOnly(true) }
    }
    public showExcelModal() {
        this.view.state.setModalExcel(!this.view.state.modalExcel);
    }
    public openCloseModalExcel() {
        let openClose = this.view.state.modalExcel ?? false;
        this.view.state.setModalExcel(!openClose);
    }
    public getGridProps() {
        const addRow: any = {};
        const copyExcel: any = {};

        let internalProps: any = {
            id: this._tableId,
            pager: {allowedPageSizes : 'all'},
            paging: {enabled: false},
            columnChooser: null,
            filterRow: null,
            headerFilter: null,
            export: { allowExportSelectedData: false },
            groupPanel: null,
            columnMinWidth: 100,
            width: "100%",
            editing: { mode: "cell", allowUpdating: true, allowAdding: false, allowDeleting: true, useIcons: true },
            scrolling: { mode: "standard", rowRenderingMode:"standard"  },
            stateStoring: { 
                enabled: true,
                type: "localStorage",
                storageKey: "storage_" + this._tableId
            } 
        };

        internalProps.onToolbarPreparing = (e: any) => onToolbarPreparing({ e: e, component: this.getDataFromTable(internalProps.id) });

        let onToolbarPreparing = (e: any) => {
            addRow.location = "after";
            addRow.widget = "dxButton";
            addRow.options = {};
            addRow.options.icon = 'plus';
            addRow.options.onClick = (event: any) => this.addRowGrid(event, e.component);

            copyExcel.location = "after";
            copyExcel.widget = "dxButton";
            copyExcel.options = {};
            copyExcel.options.icon = 'paste';
            copyExcel.options.text = this.currentLabels.get('CopyFromExcel'); //TODO
            copyExcel.options.onClick = (event:any) => { this.showExcelModal() };

            e.e.toolbarOptions.items.unshift(addRow || null, copyExcel || null);
            e.e.toolbarOptions.items.unshift({
                location: 'before',
            });
        };
        return { ...internalProps };
    }
    //#endregion

    //#region Private methods
    private initializePresenter() {
        this.basicFields = useSelector(this.context.budgetStore.selectFormBudgetByProjectTableColumnDefinition);
        this.formMasters = useSelector(this.context.budgetStore.selectFormMasters);
        this.currentTableData = useSelector(this.context.budgetStore.selectFormTableByProject);
        this.currentBudget = useSelector(this.context.budgetStore.selectCurrentBudget);
    }
    private initializeVariables() {
        this.monthsToSum = Constants.Months.Spanish;
        this.summaryConfig = [
            { column: "TotalAnio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Enero", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Febrero", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Marzo", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Abril", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Mayo", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Junio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Julio", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Agosto", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Septiembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Octubre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Noviembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT },
            { column: "Diciembre", summaryType: "sum", valueFormat: Constants.GeneralFormats.CURRENCY_FORMAT }
        ]
    }
    private initializeColumnsByColumnsDefinition() {
        let columns: BatchGridColumnProps[] = [];
        columns.push(this.getBudgetField("FinanciadorSap"));
        columns.push(this.getBudgetField("Pais"));
        columns.push(this.getBudgetField("CodigoSubvencion"));
        columns.push(this.getBudgetField("NaturalezaGastos"));
        columns.push(this.getBudgetField("RecuperacionCostes"));
        columns.push(this.getBudgetField("Pep"));
        columns.push(this.getBudgetField("EdicionPepLibre"));
        columns.push(this.getBudgetField("TotalAnio"));
        columns.push(this.getBudgetField("Enero"));
        columns.push(this.getBudgetField("Febrero"));
        columns.push(this.getBudgetField("Marzo"));
        columns.push(this.getBudgetField("Abril"));
        columns.push(this.getBudgetField("Mayo"));
        columns.push(this.getBudgetField("Junio"));
        columns.push(this.getBudgetField("Julio"));
        columns.push(this.getBudgetField("Agosto"));
        columns.push(this.getBudgetField("Septiembre"));
        columns.push(this.getBudgetField("Octubre"));
        columns.push(this.getBudgetField("Noviembre"));
        columns.push(this.getBudgetField("Diciembre"));
        this.view.state.setColumns(columns);
    }
    private getBudgetField(fieldName: string): BatchGridColumnProps {
        if (!Utilities.isNullObject(this.basicFields) || !Utilities.isNullObject(this.formMasters)) {
            let columnDefinition = this.basicFields.get(fieldName);
            let element: BatchGridColumnProps = {
                dataField: columnDefinition.Title,
                title: columnDefinition.NombreColumna,
                fieldType: columnDefinition.TipoCampoProyecta,
                id: columnDefinition.Title,
                onValueChanged: this.onChangeCellValue
            };

            if (columnDefinition.TipoCampoProyecta === Enums.FieldTypes.Select) {
                element.items = this.getSelectData(columnDefinition.OCTAVIALista);
                element.allItems = this.getSelectAllData(columnDefinition.OCTAVIALista);
            }

            if (columnDefinition.TipoCampoProyecta === Enums.FieldTypes.Checkbox) {
                element.alignment = 'center';
                element.fieldType = 'boolean';
            }

            if (["TotalAnio", "Total"].includes(fieldName)) { element.readOnly = true; }

            if (["FinanciadorSap", "Pais"].includes(fieldName)) { element.width = 220; }
            if (["NaturalezaGastos"].includes(fieldName)) { element.width = 340; }
            if (["Pep"].includes(fieldName)) { 
                element.width = 250; 
                element.requiredErrorMessage = this.currentLabels.get("EstructuraPepIncorrecta");
                element.requiredRegExp = true ;
                element.cssClass = "pointerNone";                
            }
            if(fieldName === "TotalAnio"){
                element.calculateCellValue = this.calculateTotalAnio
            }
            return element;
        }
    }
    private calculateTotalAnio(data: any) {
        const months = Constants.Months.Spanish;
        let value = 0;

        const items = Object.keys(data);
        items.forEach(key => {
            if (months.includes(key)) {
                value += data[key];
            }
        });
        return value;
    }
    private getSelectData = (list: string) => { 
        if (this.formMasters !== null) {
            switch (list) {
                case Enums.ListTypes.SAPFinancingEntity: return Utilities.processDropDownData(this.formMasters.sapFinancingEntities.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.SAPFinancingEntity, "OCTAVIACodigo");
                case Enums.ListTypes.GrantCode: return Utilities.processDropDownData(this.formMasters.grantCodes.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.GrantCode);
                case Enums.ListTypes.NatureExpenditure: {
                    let items = this.formMasters.natureExpenditures.filter((x: any) => { if ((!Utilities.isNullObject(x.PPresNatGasto) && x.PPresNatGasto) && x.OCTAVIAActivo) { return true } });
                    return Utilities.processDropDownData(items, Enums.ListTypes.NatureExpenditure);
                }
                case Enums.ListTypes.Country: {
                    return Utilities.processDropDownData(this.formMasters.countries.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.Country);
                }
                case Enums.ListTypes.PresupuestoSedeOn: {
                    return Utilities.processDropDownData(this.formMasters.sedeOn.filter((x: any) => (x.OCTAVIAActivo)));
                }
                case Enums.ListTypes.ProaCostRecovery: {
                    return Utilities.processDropDownData(this.formMasters.costRecovery.filter((x: any) => (x.OCTAVIAActivo)));
                }
            }
        }
    }
    private getSelectAllData = (list: string) => { 
        if (this.formMasters !== null) {
            switch (list) {
                case Enums.ListTypes.SAPFinancingEntity: return Utilities.processDropDownData(this.formMasters.sapFinancingEntities, Enums.ListTypes.SAPFinancingEntity, "OCTAVIACodigo");
                case Enums.ListTypes.GrantCode: return Utilities.processDropDownData(this.formMasters.grantCodes, Enums.ListTypes.GrantCode);
                case Enums.ListTypes.NatureExpenditure: {
                    let items = this.formMasters.natureExpenditures.filter((x: any) => { if (!Utilities.isNullObject(x.PPresNatGasto) && x.PPresNatGasto) { return true } });
                    return Utilities.processDropDownData(items, Enums.ListTypes.NatureExpenditure);
                }
                case Enums.ListTypes.Country: {
                    return Utilities.processDropDownData(this.formMasters.countries, Enums.ListTypes.Country);
                }
                case Enums.ListTypes.PresupuestoSedeOn: {
                    return Utilities.processDropDownData(this.formMasters.sedeOn);
                }
                case Enums.ListTypes.ProaCostRecovery: {
                    return Utilities.processDropDownData(this.formMasters.costRecovery);
                }
            }
        }
    }
    private onChangeCellValue(event: any, columns: BatchGridColumnProps[]) {    

        if(event.row.cells[5].cellElement !== undefined){
            if (event?.data?.EdicionPepLibre){                 
                const element = event.row.cells[5].cellElement;     
                element.style.pointerEvents = "inherit";
            }else{                
                const element = event.row.cells[5].cellElement;     
                element.style.pointerEvents = "none";
            }
        }
        if (event?.data?.EdicionPepLibre && ["Pep"].includes(event.column.dataField)){     
            event.data.PepManual = event.value || event.data.PepCalculado;
            event.data.Pep = event.value || event.data.PepCalculado;
        }
        if (event && event.value) {
            if ([Enums.ListTypes.SAPFinancingEntity, "Pais"].includes(event.column.dataField)) {
                event.data.PepCalculado = this.getPepString(event)
                if(!event.data.EdicionPepLibre || !event.data.Pep) event.data.Pep =  event.data.PepCalculado;
            }
            if ([Enums.ListTypes.SAPFinancingEntity].includes(event.column.dataField) && event.value && event.data.CodigoSubvencion) {
                let Financer = this.formMasters.sapFinancingEntities.filter((sapFinancer:any)=> event.value[0] == sapFinancer.Id)
                let isAeA = Financer[0] ? Financer[0].PPresTipoFondoId === 1 : false;
                let items = isAeA ? this.formMasters.grantCodes.filter((_codeAeA:any)=> (_codeAeA.Title && _codeAeA.Title[0] == "A" && _codeAeA.OCTAVIAActivo) )      
                    :   this.formMasters.grantCodes.filter((_code:any) => (_code.OCTAVIAActivo && _code.OCTAVIAFinanciadorSapId === event.value[0]))
                let updateCod = items.filter((codeSub:any) => codeSub.Id === event.data.CodigoSubvencion[0])
                event.data.CodigoSubvencion = updateCod.length ? [updateCod[0].Id] : []
            }
        }
        
    }
    
    private getPepString(event: any) {
        let _currentBudget = store.getState().budget.currentBudget;

        let format: string = "{0}.{1}.{2}.{3}";
        let regionCountryCode: string = "XXXX";
        let sapCode: string = "XXXX";
        let region: any;

        if (!Utilities.isNullObject(event.data?.FinanciadorSap)) {
            let sapId = event.data.FinanciadorSap[0];
            if (!Utilities.isNullObject(sapId)) {
                const sapFinancingResult = this.formMasters.sapFinancingEntities.find((x: any) => x.Id === sapId);
                sapCode =  sapFinancingResult?.OCTAVIACodigo || "XXXX";
            }
        }

        if (!Utilities.isNullObject(_currentBudget?.RegionCountry)) {
            region = this.formMasters.regions.find((x: any) => x.OCTAVIACodigo === _currentBudget.RegionCountry[0].code);
            if (!Utilities.isNullObject(region)) {
                regionCountryCode = region.OCTAVIACodigo;
            }
        }

        if (!Utilities.isNullObject(event.data.Pais)
            && event.data.Pais[0] !== 0) {

            let country = this.formMasters.countries.find((x: any) => x.Id === event.data.Pais[0]);

            if (!Utilities.isNullObject(country)) {
                regionCountryCode = country.OCTAVIACodigo;
            }

            if (!Utilities.isNullObject(_currentBudget?.RegionCountry)            
                && (Utilities.isNullObject(country?.PPresModificaPep) || !country?.PPresModificaPep)) {

                region = this.formMasters.regions.find((x: any) => x.OCTAVIACodigo === _currentBudget.RegionCountry[0].code);
                if (!Utilities.isNullObject(region)) {
                    let regionCod = region.OCTAVIACodigo;
                    let countryCod = country.OCTAVIACodigo;

                    regionCountryCode = String.Format("{0}{1}", regionCod.substring(0, 2), countryCod.substring(0, 2));
                }
            }
        }

        if (!Utilities.isNullObject(event.data.Pais) && event.data.Pais[0] !== 0) {
            regionCountryCode = this.formMasters.countries.find((x: any) => x.Id === event.data.Pais[0])?.OCTAVIACodigo;
        }

        let _interventionLine = (!Utilities.isNullObject(_currentBudget?.LineaIntervencionId)) ? this.formMasters.interventionLines.find((x: any) => x.Id === _currentBudget.LineaIntervencionId[0].id) : [0];
        let countryRegion: string = (!Utilities.isNullObject(_currentBudget?.RegionCountry)) ? _currentBudget.RegionCountry[0].code?.substring(0, 4) ?? '' : "";
        let interventionLineCode: string = !Utilities.isNullEmptyObject(_interventionLine) ? _interventionLine.OCTAVIACodigo : "";

        return String.Format(format, countryRegion, regionCountryCode, sapCode, !Utilities.isNullEmptyObject(interventionLineCode) ? interventionLineCode : "");

    }
    private addRowGrid = (e: any, dxGrid: dxDataGrid) => {
        if (dxGrid === null) return;

        dxGrid.saveEditData().then(data => {
            if (dxGrid.getDataSource().items().length > 0) {
                dxGrid.closeEditCell();
                dxGrid.addRow();
                const dataSource = dxGrid.getDataSource().items();
                dxGrid.closeEditCell();
                dxGrid.editRow(dataSource.length + 1)
            }
            else {
                dxGrid.addRow();
            }
        });
    }
    private getDataFromTable(tableId: string): DataGrid {
        let element = document.getElementById(tableId);
        if (Utilities.isNullEmptyObject(element)) {
            return null;
        }

        return DataGrid.getInstance(element) as DataGrid;

    }
    //#endregion

}